import styled from '@emotion/styled';
import { Text } from '@qga/roo-ui/components';

export const LabelText = styled(Text)`
  white-space: nowrap;
`;
